// extracted by mini-css-extract-plugin
export default {"ConfirmMergeContainer":"ConfirmMerge-module__ConfirmMergeContainer--g9ubs","ConfirmMergeText":"ConfirmMerge-module__ConfirmMergeText--kxshz"};